module.exports = "<div ui-view=\"\"></div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/main/main.pug
// module id = 286
// module chunks = 0